import React from "react";
import Loader from "../common/Loader";
import EmployeeDetails from "./EmployeeDetails";
import { UiText } from "../common/ui/UiText";
import InfoBlock from "../common/ui/InfoBlock";
import { makeStyles } from "@mui/styles";
import { toRem16 } from "../../scss/utils/styles";
import { useAppState } from "../../provider/AppProvider";
import moment from "moment-timezone";

const useStyles = makeStyles(() => {
    return {
        textGap: {
            marginBottom: toRem16(16),
        },
        info: {
            width: 'max-content'
        }
    };
});

function ADPPersonalInfo(props) {
    const expiryDate = localStorage.getItem("adpExpiryDate");
    const classes = useStyles();
    const { isApiLoading } = useAppState();
    if (isApiLoading) {
        return <Loader />;
    }
    return (
        <div>
            <div className={classes.textGap}>
                <UiText typographyVariant="suv_150" weight="semi_bold_600">
                    Complete your Payroll Profile
                </UiText>
            </div>
            <div className={classes.textGap}>
                <UiText>
                    In order to get paid, we need the following information.
                </UiText>
            </div>
            <div className={classes.info}>
                <InfoBlock
                    infoText={`Complete this by ${expiryDate?.replace(
                        "•",
                        " at "
                    )}`}
                />
            </div>
            <EmployeeDetails />
        </div>
    );
}

export default ADPPersonalInfo;
